import { useAuth } from '../context/AuthContext'

// Who may see and who may change Mantenimiento (units, Planilla, partes,
// assignments, people). Mirrors backend/auth_utils.py's MANTENIMIENTO_VER /
// MANTENIMIENTO_EDITAR: anyone in Operaciones sees it; only admin and the
// "mantenimiento" role change it. Commenting on a unit or a parte is open to
// everyone who sees it -- a conversation, not maintenance data.
export const MANTENIMIENTO_VER = ['admin', 'operaciones', 'warehouse', 'engineer', 'pm_po', 'mantenimiento']
export const MANTENIMIENTO_EDITAR = ['admin', 'mantenimiento']

export function usePuedeEditarMantenimiento() {
  const { hasRole } = useAuth()
  return hasRole(...MANTENIMIENTO_EDITAR)
}

// Putting people to work on a parte (start, pause, register work): whoever may change Mantenimiento, or holds the OT
// function "asignar_personas" (so the head of Operación y Mantenimiento does not also need the platform role).
// Mirrors backend/routers/capsulas.require_capsulas. Deleting a record stays with MANTENIMIENTO_EDITAR.
export function usePuedeAsignarPartes() {
  const { hasRole, user } = useAuth()
  return hasRole(...MANTENIMIENTO_EDITAR) || (user?.ot_funciones || []).includes('asignar_personas')
}

// Opening a parte: whoever may change Mantenimiento, or holds the OT function "crear_ot_mantenimiento" (the Operación y
// Mantenimiento team by default, from Permisos). Mirrors backend/routers/partes.require_partes. Editing, closing and
// cancelling a parte stay with MANTENIMIENTO_EDITAR.
export function usePuedeAbrirPartes() {
  const { hasRole, user } = useAuth()
  return hasRole(...MANTENIMIENTO_EDITAR) || (user?.ot_funciones || []).includes('crear_ot_mantenimiento')
}
